// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A1AX","option":"styles_option__3oLRW","active":"styles_active__2a9Av"};